<template>
  <div>
    <div style="margin-top: 8px; text-align: left;">
        <div>{{title}} :</div> 
        <div><i class="el-icon-phone-outline"></i> {{phone}}</div> 
        <div style="font-weight:bold;"><i class="el-icon-message" style="margin-right: 4px;"></i>{{email}}</div>
    </div>
  </div>
</template>

<script>
export default {
    name:'ContactItem',
    props:{
        title:String,
        phone: String,
        email:String
    },
    data(){
        return {}
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/common/contact_item.vue